// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4c9d97a6","455":"96870eef","884":"7be4426a","977":"240addac"}[chunkId] + ".chunk.js";
};